exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error-placeholder{color:red;font-size:.9em}.errors{border:1px solid red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5cd3953e!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/form/CheckboxInput.vue
// module id = 896
// module chunks = 2